<app-star-rating [rating]="item[field]" [disabled]="true"></app-star-rating>
